import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Mail } from "lucide-react";
import { api, formatApiError } from "../lib/api";

const inputCls = "w-full rounded-full border border-white/25 bg-white/10 px-5 py-3.5 text-sm text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-[#C1CC24]";

export const MarketingCapture = ({ source = "home" }) => {
  const [form, setForm] = useState({ name: "", email: "", phone: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/marketing/subscribe", { ...form, source });
      setDone(true);
      toast.success("You're on the list — talk soon!");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="bg-[#0d2f4d] grain relative" data-testid="marketing-capture-section">
      <div className="relative max-w-7xl mx-auto px-6 py-16 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <p className="font-accent text-lg text-[#C1CC24]">Stay in the loop</p>
          <h2 className="text-2xl sm:text-3xl font-bold text-white tracking-tight mt-2">
            Market updates, salary insights and roles worth knowing about.
          </h2>
          <p className="text-sm text-white/60 mt-3 max-w-md leading-relaxed">
            No spam, no CV piles — just the occasional email that's actually worth opening. Unsubscribe anytime.
          </p>
        </div>
        {done ? (
          <div className="flex items-center gap-3 text-white" data-testid="marketing-capture-success">
            <Mail className="text-[#C1CC24]" size={22} />
            <p className="font-heading font-bold">You're in — keep an eye on your inbox.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="grid sm:grid-cols-2 gap-3">
            <input required value={form.name} onChange={set("name")} placeholder="Your name"
              data-testid="marketing-name-input" className={inputCls} />
            <input required type="email" value={form.email} onChange={set("email")} placeholder="Email address"
              data-testid="marketing-email-input" className={inputCls} />
            <input value={form.phone} onChange={set("phone")} placeholder="Mobile (optional)"
              data-testid="marketing-phone-input" className={inputCls} />
            <button type="submit" disabled={busy} data-testid="marketing-subscribe-button"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#C1CC24] text-[#0d2f4d] font-semibold text-sm px-6 py-3.5 hover:bg-[#aeb81f] transition-colors disabled:opacity-60">
              {busy && <Loader2 size={15} className="animate-spin" />} Keep me posted
            </button>
          </form>
        )}
      </div>
    </section>
  );
};
